import React,{useState} from "react";
import './App.css';
import Filter from "./components/Flter";
import Header from "./components/Header";
// import Data from "./Data";
import Home from "./Pages/Home";
import LaterSearch from "./components/LatesrSearch";
import Card2 from "./components/Card3";
import {RouterProvider,createBrowserRouter, Route, createRoutesFromElements } from "react-router-dom";
import SearchPage from "./components/SearchPage";



function App() {
  const [searchDateArray , setSearchDateArray] = useState([])
  const searchDateHadler =(filterdArray)=> {
    setSearchDateArray(filterdArray)
  }
  // const [showDatepicker, setShowDatePicker] = useState(false);
  // const [isActive, setIsActive] = useState("Amazing views")
  // const searchClickHandler = ()=>{
  //   setShowDatePicker(!showDatepicker);
  // }
  // const closeDatePicker = ()=>{
  //   setShowDatePicker(false);
  // }
  // const fliterClickHandler = (hotelType) =>{
  //   setIsActive(hotelType);
  //   console.log(hotelType)
  // }
  // const FilteredHotel = Data.filter(hotel => {
  //   return isActive === hotel.hotelType;
  // })
  // const kk = new Date("Feb 1, 2007")  
  // const kl = kk.getMonth();
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route element={<Header onSearch={searchDateHadler}/>}> 
        <Route index element={<Home/>}></Route>
        {/* <Route path="/" element={<Filter Active={isActive} activeHotelType={fliterClickHandler}/>}></Route> */}
        {/* <Route path="/" element={<Card2 data={FilteredHotel}/>}></Route> */}
        <Route path="/search" element={<SearchPage/>}> </Route>
      </Route>
    )
  )
  return (
    <div className="App">
      <RouterProvider router={router}/>
      
      {/* <Header onClick={searchClickHandler} />
      {showDatepicker && <LaterSearch onClose={closeDatePicker} />}
      <Filter Active={isActive} activeHotelType={fliterClickHandler}/> */}
      {/* <Card2 data={FilteredHotel}/> */}
      {/* {console.log(kl)} */}
      
      {/* {console.log("Hello I am there".trim())} */}
      {/* <IconsSlider/> */}
      {/* <TotalPrice/> */}
      {/* <CardContainer/> */}
    </div>
  );
}

export default App;
